import React, { useState } from 'react';
import { motion } from "framer-motion";
import { useTranslation } from 'react-i18next';
import ProjectCard from "./ProjectCard";
import { formatProjectCardData } from "../../data/realEstatePrograms";

/**
 * Composant réutilisable pour afficher les programmes immobiliers
 * @param {Object} props - Les propriétés du composant
 * @param {Array} props.projects - Liste des programmes à afficher
 * @param {Boolean} props.showMoreButton - Afficher ou non le bouton "Voir plus" (optionnel)
 * @param {Number} props.initialCount - Nombre de projets à afficher initialement (optionnel, défaut: 3)
 */
const ProjectsDisplay = ({ 
  projects, 
  showMoreButton = false,
  initialCount = 3
}) => {
  const { t } = useTranslation();
  const [showAllProjects, setShowAllProjects] = useState(false);
  
  // Limiter le nombre de projets affichés si nécessaire
  const visibleProjects = showAllProjects 
    ? projects 
    : projects.slice(0, initialCount);

  return (
    <>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {visibleProjects.map((project) => (
          <ProjectCard 
            key={project.id} 
            project={formatProjectCardData(project, t)} 
          />
        ))}
      </div>

      {showMoreButton && !showAllProjects && projects.length > initialCount && (
        <div className="flex items-center justify-center mt-8">
          <motion.button 
            onClick={() => setShowAllProjects(true)}
            className="bg-socabeg-red text-white px-8 py-3 rounded-md hover:bg-socabeg-red/90 transition-colors text-sm font-medium text-center"
            whileHover={{ scale: 1.05 }}
          >
            {t('projects.discoverMore')}
          </motion.button>
        </div>
      )}
    </>
  );
};

export default ProjectsDisplay;
